export default __webpack_public_path__ + "static/media/night.d5b7d6f2.mp3";